//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Markup.js";
import "../no/DisplayableObject.js";
let d=[[],[[["num"],"GetElements",{R_:{elements:"Markup.Element[]"}},0,0],[[],"HideElements",{},0,0],[[],"ShowElements",{},0,0],[[],"HasCapturedView",{R_:{hasView:''}},0,0],[[],"CaptureView",{},0,0],[[],"ApplyView",{},0,0],[[],"DeleteView",{},0,0],[[],"IsActive",{R_:{isActive:''}},0,0]],[["Elements","Markup.ElementCollection",0]]];
SPLM.Markup.Markup = class extends SPLM.DisplayableObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Markup.Markup";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;